import { render, staticRenderFns } from "./NotificationClass.vue?vue&type=template&id=139e087a&scoped=true"
import script from "./NotificationClass.vue?vue&type=script&lang=js"
export * from "./NotificationClass.vue?vue&type=script&lang=js"
import style0 from "./NotificationClass.vue?vue&type=style&index=0&id=139e087a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e087a",
  null
  
)

export default component.exports